import { Box, Grid, Typography } from "@mui/material";
import MapBandsLegendItem from "./MapBandsLegendItem";

export default function MapBandsLegend() {
  return (
    <Box>
      <Typography
        variant="h4"
        component="p"
        color="common.black"
        sx={{ marginBottom: "1rem" }}
      >
        Legende
      </Typography>
      <Grid container spacing={1}>
        <MapBandsLegendItem type=">" color="#E1268C" count="100" />
        <MapBandsLegendItem type="<" color="#E74DA1" count="100" />
        <MapBandsLegendItem type="<" color="#EE80BC" count="50" />
        <MapBandsLegendItem type="<" color="#F5B3D7" count="25" />
        <MapBandsLegendItem type="<" color="#FBE0EF" count="10" />
        <MapBandsLegendItem type="=" color="#F6FBFF" count="0" />
      </Grid>
    </Box>
  );
}
